import { Navigate, useLocation } from 'react-router-dom'

import routes from '../routes.constants'

const AuthRoute = ({ children }) => {
  const location = useLocation()

  if (!localStorage.jwt) {
    return <Navigate to={`${routes.loginPage}?next=${location.pathname}`} />
  }

  return children
}

export default AuthRoute
